/*
 * Print247 - header navigation selected state.
 *
 * The black "selected" pill on a top menu item is shown ONLY when the visitor
 * reached the current page by clicking that item (or one of its dropdown
 * links) in the header. Choosing a category from the collection page banner
 * clears it, so the banner and the header stay independent.
 */
(function () {
  var KEY = 'p247NavSelection';

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function write(value) {
    try {
      if (value) sessionStorage.setItem(KEY, JSON.stringify(value));
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
  }
  function norm(path) {
    return (path || '/').replace(/\/+$/, '') || '/';
  }

  function init() {
    var nav = document.querySelector('.print247-navigation');
    if (!nav) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('.p247-nav-item'));

    // 1. Header clicks record which top-level item was chosen.
    items.forEach(function (item, index) {
      item.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', function () {
          var url = new URL(a.href, location.href);
          if (url.origin !== location.origin) return;
          write({ item: index, path: norm(url.pathname) });
        });
      });
    });

    // 2. Collection-banner category clicks clear any header selection.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.collection-banner__category')) write(null);
    }, true);

    // 3. Show the selection only while the visitor is still on the page
    //    (or a filtered view of it) that they opened from the header.
    var sel = read();
    if (!sel) return;
    var here = norm(location.pathname);
    var onPage = here === sel.path || here.indexOf(sel.path + '/') === 0;
    var item = items[sel.item];
    if (onPage && item) {
      var link = item.querySelector('.p247-nav-link');
      if (link) link.classList.add('active');
    } else {
      write(null);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
